export const messageTypes = {
  copiesUpdate: 'REVENI_COPIES_UPDATE',
}
